"use client";
import Card from "react-bootstrap/Card";
import { useI18n } from "../../i18n";

type EventCountProps = {
  noOfEvents?: number;
  totalDays?: number;
};

function EventCount({ noOfEvents, totalDays }: EventCountProps) {
  const { t } = useI18n();
  return (
    <Card
      style={{ width: "20rem", backgroundColor: "#f8f9fa", height: "170px" }}
    >
      <Card.Body>
        <Card.Subtitle className="mb-2 text-muted">
          {t("dashboard.monthEvents")}
        </Card.Subtitle>
        <br />
        <Card.Title
          style={{
            textAlign: "center",
            fontSize: "2.5rem",
          }}
        >
          {noOfEvents?.toString()}/{totalDays?.toString()}
        </Card.Title>
      </Card.Body>
    </Card>
  );
}

export default EventCount;
